export type KundaliLang = "en" | "hi";

export interface KundaliTranslations {
  name: string;
  birthDate: string;
  birthTime: string;
  birthPlace: string;
  optional: string;
  submit: string;
  namePlaceholder: string;
  placePlaceholder: string;
  savedNote: string;
  loading: string;
  phone: string;
  phonePlaceholder: string;
  phoneReason: string;
  email: string;
  emailPlaceholder: string;
}

const DEFAULT_TRANSLATIONS: Record<KundaliLang, KundaliTranslations> = {
  en: {
    name: "Your Name",
    birthDate: "Birth Date",
    birthTime: "Birth Time",
    birthPlace: "Birth Place",
    optional: "(optional)",
    submit: "Generate Free Kundali →",
    namePlaceholder: "Enter your full name",
    placePlaceholder: "City, State (e.g. Chennai, Tamil Nadu)",
    savedNote: "Your reading is saved securely so you can access it anytime.",
    loading: "Calculating your stars...",
    phone: "Mobile number",
    phonePlaceholder: "98765 43210",
    phoneReason: "We'll send your reading on WhatsApp.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
  },
  hi: {
    name: "आपका नाम",
    birthDate: "जन्म तिथि",
    birthTime: "जन्म समय",
    birthPlace: "जन्म स्थान",
    optional: "(वैकल्पिक)",
    submit: "निःशुल्क कुंडली बनाएं →",
    namePlaceholder: "अपना पूरा नाम लिखें",
    placePlaceholder: "शहर, राज्य (उदा. चेन्नई, तमिलनाडु)",
    savedNote: "आपकी कुंडली सुरक्षित रूप से सहेजी जाती है ताकि आप इसे कभी भी देख सकें।",
    loading: "गणना हो रही है...",
    phone: "Mobile number",
    phonePlaceholder: "98765 43210",
    phoneReason: "Aapki reading WhatsApp par bhejenge.",
    email: "Email",
    emailPlaceholder: "you@example.com (optional)",
  },
};

export function getKundaliTranslations(
  language: KundaliLang,
  overrides: {
    submitLabel?: string;
    savedNote?: string;
    loadingLabel?: string;
    namePlaceholder?: string;
    placePlaceholder?: string;
  } = {}
): KundaliTranslations {
  const defaults = DEFAULT_TRANSLATIONS[language];
  return {
    ...defaults,
    submit: overrides.submitLabel || defaults.submit,
    namePlaceholder: overrides.namePlaceholder || defaults.namePlaceholder,
    placePlaceholder: overrides.placePlaceholder || defaults.placePlaceholder,
    savedNote: overrides.savedNote || defaults.savedNote,
    loading: overrides.loadingLabel || defaults.loading,
  };
}
